/**
 * Created by chenjia on 2017/4/5.
 */
const lazyload = require('./unit/lazyload/lazyload');
const goTop = require('./unit/goTop/goTop');
const headFoot = require('./unit/headerFooter/headerFooter');
const price = require('./unit/price/price');
const tapEvent = require('./unit/tapEvent/tapEvent');
const webviewOpt = require('./unit/webviewOpt/webviewOpt');
const specialChooseModule = require('./module/specialChooseModule');

webviewOpt.init({
    "imageLink": "http://img10.360buyimg.com/cms/jfs/t9205/1/1962459531/3945/6d5c647a/59c21b7aN33292692.png"
});

specialChooseModule.init();
price.fn.init();
tapEvent.tapItem(true);
tapEvent.tapSale();
tapEvent.tapLink(true);
lazyload.fn.init();
goTop.fn.init();
headFoot.loadHeadAndFooter();



// WEBPACK FOOTER //
// ./src/js/specialChoose.js